export default __webpack_public_path__ + "static/media/search-icon.1c029216.svg";